import styled from 'styled-components'
import { bigLg, black } from 'utils/style-utils'

export const Box = styled.div`
  background: ${black};
`

export const StyledContainer = styled.div`
  width: 100%;
  max-width: ${bigLg}px;
  margin: 0 auto;
  display: flex;
  height: 4rem;
  padding: 0 0.75rem;
  gap: 0.75rem;
  align-items: center;
`
